import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

import Config from './config'
const env = process.env.VUE_APP_ENV
if (!firebase.apps.length) {
  firebase.initializeApp(Config[env].firebase)
}
const db = firebase.firestore()
const auth = firebase.auth()
const usersCollection = db.collection('users')
export {
  db,
  auth,
  usersCollection
}
